/**
 * Empty state FLUA — mostrado quando uma lista/tabela não tem resultados.
 * Vem com a onda-assinatura da marca em SVG animado leve, um ícone opcional
 * e ação (children). Usa cores primary/muted pra combinar com o tema.
 */
export default function EmptyStateFlua({
  icon: Icon,
  title = "Nada por aqui ainda",
  description,
  children,
  compact = false,
  className = "",
}) {
  const py = compact ? "py-8" : "py-12";
  return (
    <div
      className={`relative overflow-hidden rounded-xl border border-dashed border-border/70 bg-card/40 text-center ${py} px-6 ${className}`}
      data-testid="empty-state-flua"
    >
      {/* Onda assinatura — SVG animado (translateX suave) */}
      <svg
        className="absolute inset-x-0 bottom-0 w-full h-24 opacity-60 pointer-events-none"
        viewBox="0 0 800 200"
        preserveAspectRatio="none"
        aria-hidden
      >
        <path
          d="M0 100 Q 200 40 400 100 T 800 100"
          stroke="hsl(var(--primary))"
          strokeOpacity="0.28"
          strokeWidth="1.5"
          fill="none"
          className="flua-wave-drift"
        />
        <path
          d="M0 140 Q 200 80 400 140 T 800 140"
          stroke="hsl(var(--primary))"
          strokeOpacity="0.18"
          strokeWidth="1.5"
          fill="none"
          className="flua-wave-drift"
          style={{ animationDelay: "-2s" }}
        />
        <path
          d="M0 70 Q 200 10 400 70 T 800 70"
          stroke="hsl(var(--primary))"
          strokeOpacity="0.12"
          strokeWidth="1.5"
          fill="none"
          className="flua-wave-drift"
          style={{ animationDelay: "-4s" }}
        />
      </svg>

      <div className="relative">
        {Icon && (
          <div className="mx-auto mb-4 w-14 h-14 rounded-2xl bg-primary/10 text-primary grid place-items-center card-flua">
            <Icon className="w-6 h-6" strokeWidth={1.5} />
          </div>
        )}
        <h3 className="font-heading font-semibold text-base sm:text-lg tracking-tight">{title}</h3>
        {description && (
          <p className="text-xs sm:text-sm text-muted-foreground mt-1.5 max-w-md mx-auto font-light">
            {description}
          </p>
        )}
        {children && <div className="mt-4 flex items-center justify-center gap-2 flex-wrap">{children}</div>}
      </div>
    </div>
  );
}
